module.exports = __webpack_public_path__ + "static/media/acura-no-option-selected.f123e956.svg";